import React, { lazy } from 'react'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { routerList } from 'routes/routerList'
import { ROUTE_PATHS } from 'utils/constants/index'
import RouteValidator from './RouteValidator'

const NotFound = lazy(() => import('components/layout/NotFound'))

const SitAndGoTablesRedirect = () => {
  const { tournamentId } = useParams()
  return (
    <Navigate
      to={ROUTE_PATHS.tournamentTablesDetails.replace(':tournamentId', String(tournamentId))}
      replace
    />
  )
}

let allRoutes = []
routerList.forEach(section => {
  section.sectionChilds.forEach(route => {
    if (route.subMenus.length) {
      allRoutes = [...allRoutes, ...route.subMenus]
    }
    allRoutes.push(route)
  })
})

const CustomRoutes = () => (
  <>
    <Routes>
      <Route path='/sit-and-go' element={<Navigate to={ROUTE_PATHS.tournaments} replace />} />
      <Route path='/sit-and-go/:tournamentId/tables' element={<SitAndGoTablesRedirect />} />
      {allRoutes.map(({ path, key, ...props }) => {
        return (
          <Route
            path={path}
            key={key}
            exact
            element={<RouteValidator path={path} {...props} />}
          />
        )
      })}
      <Route
        path='*'
        element={<NotFound />}
      />
    </Routes>
  </>
)

export default CustomRoutes
